import type { ChatReceipt } from "@/lib/chatApi";

/**
 * Accusés style WhatsApp :
 * - 1 ✓ = envoyé (pas encore distribué)
 * - 2 ✓✓ = distribué
 * - 2 ✓✓ colorés = lu
 * Couleurs fixes (pas l’accent thème) pour rester lisibles sur bulles teintées.
 */
export function MessageTicks({ receipt }: { receipt?: ChatReceipt | null }) {
  const status = receipt ?? "sent";
  const double = status === "delivered" || status === "read";
  const tone =
    status === "read" ? "chat-ticks--read" : "chat-ticks--pending";

  const title =
    status === "read" ? "Lu" : status === "delivered" ? "Distribué" : "Envoyé";

  return (
    <span
      className={`chat-ticks inline-flex items-center leading-none ${tone}`}
      title={title}
      aria-label={title}
    >
      {double ? <DoubleCheckIcon /> : <SingleCheckIcon />}
    </span>
  );
}

/** Un seul V — envoyé */
function SingleCheckIcon() {
  return (
    <svg viewBox="0 0 12 11" width="12" height="11" aria-hidden>
      <path
        fill="currentColor"
        d="M11.157.5a.5.5 0 0 1 .047.707L4.718 8.22a.5.5 0 0 1-.722.016L.79 5.145a.5.5 0 1 1 .69-.724l2.812 2.68L10.45.547a.5.5 0 0 1 .707-.047z"
      />
    </svg>
  );
}

/** Double V chevauchés façon WhatsApp */
function DoubleCheckIcon() {
  return (
    <svg viewBox="0 0 16 11" width="16" height="11" aria-hidden>
      <path
        fill="currentColor"
        d="M11.157.5a.5.5 0 0 1 .047.707L4.718 8.22a.5.5 0 0 1-.722.016L.79 5.145a.5.5 0 1 1 .69-.724l2.812 2.68L10.45.547a.5.5 0 0 1 .707-.047z"
      />
      <path
        fill="currentColor"
        d="M15.157.5a.5.5 0 0 1 .047.707L8.718 8.22a.5.5 0 0 1-.722.016l-.424-.404a.5.5 0 0 1 .69-.724l.07.067 5.812-6.375A.5.5 0 0 1 15.157.5z"
      />
    </svg>
  );
}
